import { AspectRatio } from "components/ui/aspect-ratio";
import React, { useEffect, useState } from "react";
import { Service } from "utils/services";

const NewFeedImagesSlideSponsor: React.FC<{
  banner: any | undefined;
  onOpenPostModal: (postId: string) => void;
}> = ({ banner, onOpenPostModal }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [images, setImages] = useState<any[]>([]);
  const [aspectRatio, setAspectRatio] = useState<number>(1.0);

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev === 0 ? images?.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev === images?.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    if (banner) {
      setImages(banner.post_attachments);

      const calculatedAspectRatio = Service.toDouble(banner?.post_attachments[0].attachment_media_width) / Service.toDouble(banner?.post_attachments[0].attachment_media_height);

      setAspectRatio(calculatedAspectRatio);
    }
  }, [banner]);

  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === images?.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  if (!banner) return <></>;

  return (
    <div onClick={() => onOpenPostModal(banner.provider_post_id)} id="default-carousel" className="relative w-full z-50">
      {/* Carousel wrapper */}
      <AspectRatio className={`relative overflow-hidden rounded-lg`} ratio={aspectRatio}>
        {images?.map((image, index) => (
          <div key={image.attachment_id} className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${index === currentSlide ? "opacity-100" : "opacity-0"}`}>
            <img src={image.media_file_src} className="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt={`Slide ${index + 1}`} />
          </div>
        ))}
      </AspectRatio>
      {/* Slider indicators */}
      <div className="absolute z-30 flex -translate-x-1/2 bottom-3 left-1/2 space-x-3 rtl:space-x-reverse">
        {images.map((_, index) => (
          <button
            key={index}
            type="button"
            className={`w-3 h-3 rounded-full ${currentSlide === index ? "bg-red-400" : "bg-gray-800/60"}`}
            aria-current={currentSlide === index}
            aria-label={`Slide ${index + 1}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default NewFeedImagesSlideSponsor;

